import * as React from 'react';
import { FC, MutableRefObject, useCallback } from 'react';
import RouteChangeListener from './RouteChangeListener';

const ScrollTopOnRouteChange: FC<
  React.PropsWithChildren<RouteChangeScrollTopProps>
> = ({ scrollTarget }) => {
  const handleRouteChange = useCallback(() => {
    scrollTarget.current?.scrollTo(0, 0);
  }, [scrollTarget]);

  return <RouteChangeListener onRouteChange={handleRouteChange} />;
};

interface RouteChangeScrollTopProps {
  scrollTarget: MutableRefObject<HTMLElement | undefined>;
}

export default ScrollTopOnRouteChange;
